import { IComponentOptions } from "angular";
import { ContactBookDetailController } from "./controller";

export const vsName = "contactBookDetailComponent";

export const contactBookDetailComponentOptions: IComponentOptions = {
  controller: ContactBookDetailController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contactBookDetail: "<",
  },
};
